import React from 'react';
import './Logo.css';
import classes from './Logo.css';
import { Link } from 'react-router-dom';

// import proCodeLogo from '../../Assets/Images/procode-logo.jpg';

const logo = (props) => (
    <div className={classes.Logo}>
        <Link to="/">
            <span className={classes.Color1}>Pro</span>
            <span className={classes.Color2}>Code</span>
        </Link>
    </div>
);

export default logo;


// WEBPACK FOOTER //
// ./src/Components/Logo/Logo.js